import { Grid } from "@mui/material";
import React from "react";
import { GridProps } from "@mui/material/Grid";
import { FormBorder } from "../Forms/FormBorder";

interface BorderedGridItemWithMessageProps {
  message: string;
}

export const BorderedGridItemWithMessage = ({
  message,
}: BorderedGridItemWithMessageProps & GridProps) => {
  const padding = "2rem";
  return (
    <FormBorder>
      <Grid
        container
        justifyContent="center"
        alignContent="center"
        sx={{ pl: padding, pr: padding }}
      >
        <Grid item>{message}</Grid>
      </Grid>
    </FormBorder>
  );
};
